module.exports = __webpack_public_path__ + "static/padPal.1b3fe215.png";